import { mapValues } from 'lodash'
import type { App } from 'vue'

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $filterPlugin: FilterPlugin
        $f: any
    }
}

export class FilterPlugin {

    protected filters: Record<string, Function> = {};
    protected context: any = null

    protected decorated = false;
    protected app: App;

    install(app: App, context: any) {

        this.context = context;
        this.app = app;

        app.config.globalProperties.$f = this.decorateFilters(this.filters);
        app.config.globalProperties.$filterPlugin = this;

        this.decorated = true;
    }

    filter(name, filter) {

        this.filters[name] = filter;

        if(this.decorated){
            this.app.config.globalProperties.$f = this.decorateFilters(this.filters);
        }

        return this;
    }

    protected decorateFilters(filters) {

        const bind = {
            context: this.context
        }

        return mapValues(filters, filter => filter.bind(bind))
    }
}